<template>
  <div>
    <EstateAdministrationCostCalculator
      @signup="signup"
      @success="showSuccessMessage"
    />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
    <ErrorSnackbar v-model="showError" />
  </div>
</template>
<script>
  import EstateAdministrationCostCalculator from './EstateAdministrationCostCalculator.vue';
  import SuccessSnackbar from '../../common/SuccessSnackbar.vue';
  import ErrorSnackbar from '../../common/ErrorSnackbar.vue';
  export default {
    name: 'EstateAdministrationCostCalculatorContainerQW',
    components: {
      EstateAdministrationCostCalculator,
      SuccessSnackbar,
      ErrorSnackbar,
    },
    data() {
      return {
        successMessage: null,
        showSuccess: false,
        showError: false,
      };
    },
    computed: {},
    methods: {
      signup() {
        this.$router.push({ name: 'SignUpPage' });
      },
      showSuccessMessage(success) {
        if (success) {
          this.successMessage =
            'Thank you. One of our specialists will contact you to assist.';
          this.showSuccess = true;
        } else {
          this.showError = true;
        }
      },
    },
  };
</script>
